module.exports = "/static/assets/82fe1cef63c1d080dd48d7625f6b8b5a.png";